 <template>
  <div>
    <h2>"$emit" sends the event from parent component to child component and in return child component emit data back to parent component</h2>
    <br />
    <v-card>
      <v-card-title>Parent Component</v-card-title>
      <v-card-text>
       <pre>
         <code>&lt;!-- Parent.vue --&gt;
&lt;template&gt;
  &lt;div&gt;
    &lt;!--
    Listen for `childToParent`: the first parameter of the `$emit` method
    in the child component. We're also listening and reacting to an
    `increment` event - in this case, we increment a counter inline.
    --&gt;
    &lt;v-card&gt;
    &lt;v-card-title&gt;Value : {{ dummydata1 }}&lt;br/&gt;Increment : {{ dummydata2 }}&lt;/v-card-title&gt;
    &lt;Child :parentData="myData" v-on:childToParent="onChildClick" v-on:increment="counter++"&gt;&lt;/PassProps&gt;
    &lt;/v-card&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
import Child from '@/components/Child.vue'
export default {
  data () {
    return {
      counter: 0,
      fromChild: '', // This value is set to the value emitted by the child
    }
  },
  name: 'about',
  components: {
    Child
  },
  methods: {
    // Triggered when `childToParent` event is emitted by the child.
    onChildClick (value) {
      this.fromChild = value
    }
  }
}
&lt;/script&gt;</code>
       </pre>
       </v-card-text>
    </v-card>
    <br />

    <v-card>
      <v-card-title>Child Component</v-card-title>
      <v-card-text>
       <pre>
         <code>&lt;!-- Child.vue --&gt;
&lt;template&gt;
  &lt;div class="child"&gt;
    &lt;!--set a variable then trigger a method which calls `$emit()`--&gt;
    &lt;v-text-field
      solo-inverted
      id="child-input"
      name="msg"
      v-model="childMessage"
      v-on:keyup="emitToParent"
      placeholder="Enter the value"
    /&gt;
    &lt;!-- Simplest - call `$emit()` inline--&gt;
    &lt;v-btn v-on:click="$emit('increment')" color="primary"
      &gt;Click me to increment!&lt;/v-btn&gt;
  &lt;/div&gt;
&lt;/template&gt;
&lt;script&gt;
export default {
  data() {
    return {
      childMessage: ''
    }
  },
  name: 'Child',
  methods: {
    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the &lt;template&gt; call in the parent. The second parameter is the payload.
    emitToParent (event) {
      this.$emit('childToParent', this.childMessage)
    }
  }
}
&lt;/script&gt;</code>
       </pre>
      </v-card-text>
    </v-card>    
  </div>
</template>

    <script>

export default {
  name: "EmitTutorial",
  data() {
    return{
      dummydata1 : "{{ this.fromChild }}",
      dummydata2 : "{{ this.counter }}",
    }
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss">

</style>
